$(document).ready(function(){

  $('.m-menu').click(function(){
    $('html, body').toggleClass('noscroll');
    $('body').toggleClass('m-menu-open');
  });

  $('.gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // check if first element is a CTA, if so show it at the bottom of the page
  $firstContentDiv = $('.content').children().first('div');
  $hasCTA = $firstContentDiv.hasClass('cta-block');
  if($hasCTA){
  	$('.content').css({'margin-top':'calc(100vh - '+$firstContentDiv.height()+'px'})
  }

  if($('body').hasClass('the-view-page')){
    // the view switcher
    $('.c-n').click(function(){
      $('html, body').animate({
          scrollTop: 0
      }, 200);
      $('.compass').removeClass().addClass('compass northbound')
    });
    $('.c-e').click(function(){
      $('html, body').animate({
          scrollTop: $("#east").offset().top - 145
      }, 200);
      $('.compass').removeClass().addClass('compass eastbound')
    });
    $('.c-s').click(function(){
      $('html, body').animate({
          scrollTop: $("#south").offset().top - 145
      }, 200);
      $('.compass').removeClass().addClass('compass southbound')
    });
    $('.c-w').click(function(){
      $('html, body').animate({
          scrollTop: $("#west").offset().top - 145
      }, 200);
      $('.compass').removeClass().addClass('compass westbound')
    });

    var contentHeight = $('.content').height();
    var bodyHeight = $('body').height();
    var maxScroll = contentHeight - bodyHeight + 145 + 169;
    $(window).scroll(function () {
      var scrollPct = (window.scrollY)/maxScroll*100;
      if(scrollPct < 25){
        $('.compass').removeClass().addClass('compass northbound')
      }
      if(scrollPct >= 25 && scrollPct < 50){
        $('.compass').removeClass().addClass('compass eastbound')
      }
      if(scrollPct >= 50 && scrollPct < 75){
        $('.compass').removeClass().addClass('compass southbound')
      }
      if(scrollPct >= 75 ){
        $('.compass').removeClass().addClass('compass westbound')
      }
    });

    $(window).resize(function () {
      contentHeight = $('.content').height();
      bodyHeight = $('body').height();
      maxScroll = contentHeight - bodyHeight + 145 + 169;
    })
  }


  // Homepage video fallback for mobile
  if($('body').hasClass('home')){
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      $('.home').addClass('no-vid');
    }
  }


  var scrolled = 0;
  window.addEventListener('scroll', handleScroll);
  var scrollOffset = parseInt($('.content').css('marginTop')) - $('.header').outerHeight() ;

  function handleScroll() {
    scrolled = window.scrollY;
    document.querySelector('body').classList.remove('r-menu-open');
    // var scrollOffset = 300;

    if (scrolled > scrollOffset) {
      document.querySelector('body').classList.add('scrolling');
    }else {
      document.querySelector('body').classList.remove('scrolling');
      if (!$('body').hasClass('m-menu-open')) {

        document.querySelector('body').classList.remove('r-menu-open');
      }
    }
  }


  // Simulation tool
  $( '.sim-btn' ).click(function(e){
    e.preventDefault();
    e.stopPropagation();
    this.insertAdjacentHTML( 'afterend', '<iframe class="i-sim" src="https://simulation.hoostknokkeheist.be/light" frameborder="0" scrolling="no"></iframe>' );
    $('body').addClass('tool-open');
  })

  $('#close-tool').click(function(){
    $('.i-sim').remove();
    $('body').removeClass('tool-open')
  })


});